import { agent, API_MAP } from 'helpers';
import moment from 'moment';
import { EFromPageTransfer } from 'v2/interfaces/financial';

class FinancialService {
  static showNewFinancialStatement(firstParam?: boolean) {
    const params = new URL(document.location.href).searchParams;
    const showNew = !!params.get('new-financial-statement') && params.get('new-financial-statement') === 'true';
    const initialUrl = firstParam ? '?' : '&';

    return showNew ? `${initialUrl}new_financial_statement=true` : '';
  }

  static loadMyExtract(page?: number, filters?: any) {
    const defaultEndpoint = `${API_MAP.loadMyExtract}?per_page=50&page=${page}&order_by=DESC${this.showNewFinancialStatement()}`;

    if (filters && filters.period) {
      let newFilters = `transaction_at=${filters.period.start}&transaction_at_final=${moment(filters.period.end).format('YYYY-MM-DD')}`;

      return agent.get(`${defaultEndpoint}&${newFilters}`);
    }

    return agent.get(defaultEndpoint);
  }

  static loadMyBlockedExtract() {
    return agent.get(`${API_MAP.loadMyBlockedExtract}${this.showNewFinancialStatement(true)}`);
  }

  static loadMyFutureExtract() {
    return agent.get(`${API_MAP.loadMyFutureExtract}${this.showNewFinancialStatement(true)}`);
  }

  static loadExtractItems(date: any) {
    return agent.get(`${API_MAP.loadExtractItems}`.replace('{date}', date));
  }

  static availableTransfer(customerType: string) {
    return agent.get(`${API_MAP.availableTransfer}`.replace('{customerType}', customerType));
  }

  static bankTransfer(value: number, id: number, commissions: Array<any>) {
    return agent.post(`${API_MAP.bankTransfer}`, { value, transfer_method_id: id, commissions, from: EFromPageTransfer.OLD_CARD });
  }

  static anticipationTransfer(invoicesId: any[]) {
    return agent.post(`${API_MAP.anticipationTransfer}`, { invoices: invoicesId });
  }

  static listInvoicesAnticipation() {
    return agent.get(`${API_MAP.listInvoicesAnticipation}`);
  }

  static listTransfers() {
    return agent.get(`${API_MAP.listTransfers}`);
  }

  static loadFilterByMonth() {
    return agent.get(`${API_MAP.loadFilterByMonth}`);
  }

  static infoMoneyTransferFile(id: any, email: string) {
    return agent.post(`${API_MAP.infoMoneyTransferFile}`.replace('{id}', id), { destination: email });
  }
}

export default FinancialService;
